import { render } from "./InventoryStartRegisterView.vue?vue&type=template&id=80ed3e78&scoped=true"
import script from "./InventoryStartRegisterView.vue?vue&type=script&lang=js"
export * from "./InventoryStartRegisterView.vue?vue&type=script&lang=js"

import "./InventoryStartRegisterView.vue?vue&type=style&index=0&id=80ed3e78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80ed3e78"]])

export default __exports__